import { BOOKINGS_APP_DEF_ID } from '../const';
export function getInstance(_ref) {
  let {
    wixCodeApi,
    appParams
  } = _ref;
  return wixCodeApi.site.getAppToken(BOOKINGS_APP_DEF_ID) || appParams.instance;
}
//# sourceMappingURL=getInstance.js.map